import React from 'react'
import styled from '@emotion/styled/macro'

export const Tab = styled('div')`
  font-size: 14px;
  background: ${({ active }) => (active ? '#fff' : 'rgb(221, 221, 221)')};
  color: ${({ active }) => (active ? '#2C2D3F' : '#2C2D3F')};
  transition: background 0.1s ease-out, transform 0.3s ease-out;
  padding: 15px 50px;
  border-radius: 12px 12px 0 0;
  margin-right: 1px;

  ${({ active }) => active && `padding-top: 20px;`}

  &:hover,
  &:visited {
    cursor: pointer;
  }
`

export const TabsContainer = styled('div')`
  display: flex;
  justify-content: flex-start;
  border-radius: 12px 0 0 0;
  align-items: baseline;
`

export const Tabs = props => {
  return (
    <div>
      <TabsContainer>{props.children}</TabsContainer>
    </div>
  )
}
